"use client";

import React from 'react';
import Image from './Image';
import Binance from '@/assets/images/Binance.svg'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import { Autoplay } from "swiper/modules";
import 'swiper/css';

SwiperCore.use([Autoplay]);

const Trusted = () => {

    return (
        <div 
          className='h-[500px] mt-24 flex items-center justify-center'
          data-aos="fade-up"
          data-aos-delay="500"
          data-aos-distance="1000px"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
            <div 
              className='text-center'
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-duration="300"
              data-aos-easing="ease-in-out"
            >
                <p className='relative z-20 gradient_bg_text bg-grad-title text-center text-[60px] font-bold leading-[78px] tracking-[-1.6px] w-full'>
                    Trusted By the best
                </p>
                <p className='text-center text-[17px] text-textColor w-5/12 min-w-[268px] ml-auto mr-auto mt-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                <div className='pt-[62px] pb-[88px] radial_gradient_mask'>
                    <Swiper
                        className={`w-full max-w-[100vw]`}
                        navigation={false}
                        centeredSlides={true}
                        centeredSlidesBounds={true}
                        loop={true}
                        spaceBetween={0}
                        slidesPerView={3.75}
                        autoplay={{
                            delay: 10,
                            disableOnInteraction: false,
                        }}
                        speed={5000}
                    >
                        {
                            Array(10).fill(0).map((item:any, index:number) => (
                                <SwiperSlide key={index} className='!w-fit py-4 px-2'>
                                    <div className='px-[50px] py-[40px] border-[1px] border-button-border rounded-md bg-grad-binance backdrop-blur-[9.3.px] shadow-[0px_0px_26px_0px] shadow-button-border/50'>
                                        <Image src={Binance} width={212} className='' alt='Binance'/>
                                    </div>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default Trusted;